<template src="./EpicAccountSearch.html">
</template>
<script>
  import loading from '@/components/PageLoader'
  import list from "@/components/core/CoreBMSMatchList"
  import echosService from "@/services/echosService.js"
  import { agencycode, instance } from "@/constants"
  import * as epicApi from "@/epicApi.js"
  import FilterModalVue from '@/components/global/FilterModal'
  import LoadModal from '@/components/global/Loading'
  import { ref, computed } from 'vue'
  export default {
    computed: {
      agencycode() {
        return agencycode
      },
      mappedAgencyFilters() {
        return this.userAgencies.map(agency => ({
          value: agency.code,
          text: agency.description
        }));
      }
    },
    components: {
      loading,
      list,
      'filter-modal': FilterModalVue,
      'loading-modal': LoadModal
    },
    data() {
      return {
        isLoading: true,
        actions: {
          href: '',
          text: ''
        },
        selectedUserAgency: [],
        searchAllAgencies: true,
        selectedPostal: '',
        selectedAccountName: '',
        loadingMessage: '',
        percentComplete: 0,
        requiredNumberOfSearchesComplete: 0,
        epicDestinationList: [],
        epicUSAgencyCodeList: [],
        epicCAAgencyCodeList: [],
        showEpicSearchError: false,
        showEpicLoadError: false,
        showCompletedModal: false,
        isEpicUser: false,
        epicDestinations: [],
        epicDestinationResultsLoaded: [],
        breadcrumbs: [
          { text: this.$t("EpicAccountSearch"), active: true }
        ],
        userAgencies: [],
        selectedCoreClientUrls: [],
        selectedCoreClientRequiresProducerAccess: false,
        epicTableList: {
          mainHeader: this.$t("EpicClientAccount"),
          idProperty: "clientId",
          filterOn: ["accountName", "address.city", "address.stateOrProvinceCode", "clientLookupCode"],
          filter: null,
          dataArray: [],
          initialValue: null,
          fields: [
            { key: "accountName", label: this.$t("Name"), sortable: true },
            { key: "destination", label: this.$t("BMS"), sortable: true },
            { key: "angecyCodeName", label: this.$t("Agency"), sortable: false },
            { key: "address.city", label: this.$t("City"), sortable: true },
            { key: "address.stateOrProvinceCode", label: this.$t("StateProvince"), sortable: true },
            { key: "clientTypeCode", label: this.$t("ClientType"), sortable: true },
            { key: "isActive", label: this.$t("Status"), sortable: true },
            { key: "clientLookupCode", label: this.$t("ClientCode"), sortable: true },
            { key: "clientId", label: this.$t("PrimaryKey"), sortable: true },
            { key: "producerName", label: this.$t("Producer"), sortable: false },
            { key: "actions", label: this.$t("Actions"), sortable: false }
          ]
        },
      }
    },
    mounted() {
      this.loadingMessage = this.$t('Loading');
      this.isLoading = true;
      this.datePickerPattern = /(0[1-9]|[12][0-9]|3[01])[/](0[1-9]|1[012])[/](19|20)\d\d/g;
      //this.checkUserEpicInstances();
      this.loadPageData();
    },
    methods: {
      loadPageData() {
        this.percentComplete = 50;
        let app = this;
        app.showEpicLoadError = false;
        echosService.getUserEpicInstances().then((data) => {
          app.showEpicLoadError = false;
          app.epicDestinations = data;
          if (app.epicDestinations.length > 0) {
            app.isEpicUser = true;
            app.setUserStructure(app.epicDestinations);
            this.percentComplete = 0
          } else {
            app.isEpicUser = false;
          }
        }).catch(error => {
          app.isLoading = false;
          app.showEpicLoadError = true;
          this.percentComplete = 0
        });
        
      },
      setUserStructure(epicDestinations) {
        let app = this;
        this.userAgencies = [];
        this.epicUSAgencyCodeList = [];
        this.epicCAAgencyCodeList = [];
        this.epicDestinationList.forEach((destination) => {
          echosService.getUserStructure(destination).then((data) => {
            //prevent duplicates
            const seenCodes = new Set(this.userAgencies.map(a => a.code));

            data.structureTree.agencies.forEach((agency) => {
              if (agency.code != null && !seenCodes.has(agency.code)) {
                if (destination === 'US') { this.epicUSAgencyCodeList.push(agency.code) } else { this.epicCAAgencyCodeList.push(agency.code) }
                this.userAgencies.push(agency);
                seenCodes.add(agency.code);
              }
            });
            if (data.defaultAgencyCode) {
              const defaultAgency = data.structureTree.agencies.find(a => a.code === data.defaultAgencyCode);
              if (defaultAgency) this.selectedUserAgency.push(defaultAgency);
            }
          })
            .catch(error => {
              console.log(error);
              app.isLoading = false;
            });
        });
        app.isLoading = false;
      },
      agencyFilterSelect() {
        this.$refs.filterBox.showFilterOptions(
          this.mappedAgencyFilters,
          this.selectedUserAgency.map(agency => agency.code)
        );
      },
      onFiltersApplied(selectedFilters) {
        this.selectedUserAgency = this.userAgencies.filter(agency =>
          selectedFilters.includes(agency.code)
        );
      },
      closeCompletedModal() {
        this.showCompletedModal = false;
      },
      async refreshEpicAccounts() {
        if (this.isLoading) {
          // A search is already running - ignore this click rather than letting two
          // overlapping searches race, where an older, slower one could finish last
          // and overwrite a newer search's results with stale data.
          return;
        }

        if (this.epicDestinationList.length === 0) {
          alert(this.$t('SearchAlertNoEpicSelected'));
          return;
        }
        if (!this.searchAllAgencies && this.selectedUserAgency.length == 0) {
          alert(this.$t('SearchAlertNoAgencySelected'));
          return;
        }

        // One task per checked destination, carrying the full list of agency
        // codes that destination's search should run against.
        const tasks = [];
        if (this.searchAllAgencies) {
          // No filter in play - send every known agency code for each checked destination.
          for (const destination of this.epicDestinationList) {
            const agencyCodes = destination === 'US'
              ? this.epicUSAgencyCodeList
              : this.epicCAAgencyCodeList;

            if (agencyCodes.length > 0) {
              tasks.push({ destination, agencyCodes });
            }
          }
        } else {
          // Filter in play - send only the agencies the user selected, split per destination.
          for (const destination of this.epicDestinationList) {
            const agencyCodes = this.selectedUserAgency
              .map(agency => agency.code.trim().toUpperCase())
              .filter(code =>
                (destination === 'US' && this.epicUSAgencyCodeList.includes(code)) ||
                (destination === 'CA' && this.epicCAAgencyCodeList.includes(code))
              );

            if (agencyCodes.length > 0) {
              tasks.push({ destination, agencyCodes });
            }
          }
        }

        const total = tasks.length;
        let completed = 0;
        this.percentComplete = 0;
        this.epicTableList.dataArray = [];

        if (this.selectedUserAgency && (this.selectedAccountName || this.selectedPostal)) {
          this.showEpicSearchError = false;
          this.isLoading = true;

          try {
            const allResults = [];

            for (const task of tasks) {
              this.loadingMessage = this.$t('Searching') + " Epic " + task.destination;

              // Pulls every page for this task in one go, not just the requested page
              const taskResults = await this.fetchAllPagesForTask(task);
              allResults.push(...taskResults);

              completed++;
              this.percentComplete = Math.round((completed / total) * 100);
            }

            // Single write with the complete, aggregated result set.
            // The list component paginates this client-side from here on.
            this.epicTableList.dataArray = allResults;
          } catch (error) {
            this.epicAccountSearchError(error);
          } finally {
            this.isLoading = false;
            this.loadingMessage = "";
            this.percentComplete = 0;
          }
        } else {
          this.showEpicSearchError = true;
          this.percentComplete = 0;
        }
      },
      // The API now returns the complete result set for a task in one call,
      // so this just fetches once and hands back the decorated results.
      // Bootstrap's pagination (in the list child) slices the full array client-side from here.
      async fetchAllPagesForTask(task) {
        // Mirrors FetchAccountByAgenciesArgs exactly.
        const payload = {
          EpicDestination: this.destinationToEnumValue(task.destination),
          ClientId: null,
          AccountName: this.selectedAccountName,
          ZipCode: this.selectedPostal ? this.selectedPostal : null,
          AgencyCodes: task.agencyCodes
        };

        const response = await epicApi.epicAccountSearchByAgencies(payload);

        // response.data may be the array itself, or an object wrapping a results array -
        // handle either so a shape change doesn't silently drop rows.
        const results = Array.isArray(response.data) ? response.data : response.data.results;

        return this.decorateResults(results || [], task.destination);
      },
      // Matches EchosClientDestination: US = 0, CA = 1.
      // If the API is actually configured with a string enum converter,
      // send task.destination itself ('US'/'CA') instead.
      destinationToEnumValue(destination) {
        return destination === 'CA' ? 1 : 0;
      },
      decorateResults(results, destination) {
        return results.map(item => ({
          ...item,
          destination,
          actions: [
            {
              href: 'javascript:void(0);',
              text: this.$t("ManualSync")
            },
            {
              href: 'javascript:void(0);',
              text: this.$t("ViewCoreRecord")
            }
          ]
        }));
      },
      getDynamicsInstance(agencyCode) {
        const code = agencyCode.trim().toUpperCase();
        const viuAgencyCodes = [agencycode.viu, agencycode.wfp, agencycode.atm];

        return viuAgencyCodes.includes(code) ? instance.viu : instance.enterprise;
      },
      epicAccountSearchError(error) {
        this.isLoading = false;
        console.error(error);
      },
      buildManualSyncPayload(id) {
        const client = this.epicTableList.dataArray.find(client => client.clientId === id);
        const agencyId = client.structures[0].agencyCode.trim().toUpperCase();

        return {
          DynamicsInstanceName: this.getDynamicsInstance(agencyId),
          Destination: client.destination,
          EpicClientId: id
        };
      },
      syncClient(id) {
        const payload = this.buildManualSyncPayload(id);
        epicApi.triggerManualSync(payload, this.triggerSyncCompleted, this.triggerSyncError);
      },
      triggerSyncCompleted() {
        this.isLoading = false;
        this.showCompletedModal = true;
      },
      triggerSyncError(error) {
        this.isLoading = false;
        console.error(error);
      },
      viewCoreRecord(client) {
        const agencyId = client.structures[0].agencyCode
        const destination = client.destination
        if (destination !== 'US' && destination !== 'CA') {
          return
        }

        const dynamicsInstance = this.getDynamicsInstance(agencyId)

        this.selectedCoreClientRequiresProducerAccess = dynamicsInstance === instance.enterprise
        epicApi.getDynamicsLinksByEpicAccountId(
          destination,
          client.clientId,
          dynamicsInstance,
          this.coreRecordsLoaded)
      },
      coreRecordsLoaded(results) {
        this.selectedCoreClientUrls = results.filter(Boolean);
        this.$bvModal.show('coreModal');
      },
      epicSelectionChanged(event) {
        // "event" is the new set of checked destinations. Anything NOT in it just
        // got unchecked - drop any selected filter agencies that belonged to it,
        // using the old code lists before setUserStructure clears/rebuilds them below.
        if (!event.includes('US')) {
          this.selectedUserAgency = this.selectedUserAgency.filter(
            agency => !this.epicUSAgencyCodeList.includes(agency.code.trim().toUpperCase())
          );
        }
        if (!event.includes('CA')) {
          this.selectedUserAgency = this.selectedUserAgency.filter(
            agency => !this.epicCAAgencyCodeList.includes(agency.code.trim().toUpperCase())
          );
        }

        this.setUserStructure(event);
      },
      showDestinationSelector() {
        return this.epicDestinations.length > 1;
      },
      clearForm() {
        this.userAgencies = [];
        this.selectedUserAgency = '';
        this.epicTableList.dataArray = [];
        this.selectedPostal = '';
        this.epicTableList.filter = null;
        this.selectedAccountName = '';
        this.showEpicSearchError = false;
      }
    },
    watch: {
      searchAllAgencies(newValue, oldValue) {
        if (this.epicDestinationList.length === 0) {
          alert("You have not selected an EPIC instance. Select either Epic USA, Epic Canada, or both to see filter options.");
          return
        }
      }
    }
  }
</script>
